import { types } from 'mobx-state-tree';

const ProductFreeTextField = types.model('ProductFreeTextField', {
  name: types.string,
  value: types.string
});

export default ProductFreeTextField;
